import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const loaderSlice = createSlice({
    name: 'loading',
    initialState: {
        isLoading: false
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
    },
});

export const { setIsLoading } = loaderSlice.actions;

export default loaderSlice.reducer;
